import React from 'react';
import {useTranslation} from 'react-i18next';
import {useNavigate} from 'react-router-dom';

import {DEMO_VIDEO_URL} from '../../../settings/settings';
import {ScreenTracker} from '../../../utils/ScreenTracker';
import {CLARITY_UNMASK} from '../../../utils/clarity/unmask';
import {MOBILE_EVENTS, PLATFORMS_PATH} from '../mobileContinue';

/**
 * «Guardamos tu avance»: adonde lleva, en el celular, «Guardar y seguir después» desde el paso de
 * plataformas (UD-23, versión del 01/11).
 *
 * Confirma, no ordena. La primera versión se llamaba «Sigues desde la computadora» y empujaba a
 * mandarse el link; fede la dio vuelta («quizás en ese momento no puede»). Ahora dice lo que ya pasó
 * (el link está en su correo, desde el celular o la computadora), ofrece la demo grabada y la vuelta a
 * conectar. Reemplaza al listado de clientes como destino de esa salida: para quien no conectó nada el
 * listado está vacío, y en las grabaciones la persona volvía a él y se iba en segundos.
 */
export function StepSavedProgress() {
    const {t} = useTranslation();
    const navigate = useNavigate();

    return (
        <div className="ob-step-body ob-continue">
            <header className="ob-head">
                <span className="ob-done-check" aria-hidden="true">
                    <svg width="34" height="34" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                         strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
                        <circle cx="12" cy="12" r="9"/>
                        <path d="M8 12.5l2.5 2.5L16 9.5"/>
                    </svg>
                </span>
                <h1 {...CLARITY_UNMASK}>{t('onboarding.mobile.saved_title')}</h1>
                <p {...CLARITY_UNMASK}>{t('onboarding.mobile.saved_body')}</p>
            </header>

            <section className="ob-continue__demo" aria-labelledby="ob-continue-demo-title">
                <h2 id="ob-continue-demo-title" {...CLARITY_UNMASK}>{t('onboarding.mobile.demo_title')}</h2>
                <p {...CLARITY_UNMASK}>{t('onboarding.mobile.demo_body')}</p>
                <a className="ob-btn -ghost" href={DEMO_VIDEO_URL} target="_blank" rel="noopener noreferrer"
                   onClick={() => ScreenTracker.recordEvent(MOBILE_EVENTS.demo)} {...CLARITY_UNMASK}>
                    {t('onboarding.mobile.demo_cta')}
                </a>
            </section>

            <div className="ob-continue__back">
                <button type="button" className="ob-link" onClick={() => navigate(PLATFORMS_PATH)} {...CLARITY_UNMASK}>
                    {t('onboarding.mobile.connect_now')}
                </button>
            </div>
        </div>
    );
}
